/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseOrderConfirmContent,
    JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseOrderConfirmContentFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseOrderConfirmContentFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseOrderConfirmContentToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseOrderConfirmContent';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse
     */
    acptNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse
     */
    acptDtlNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse
     */
    linkAcptNo?: string;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseOrderConfirmContent}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse
     */
    orderConfirmContents?: JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseOrderConfirmContent;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse
     */
    tel?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse
     */
    businessHourTitle1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse
     */
    businessHour1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse
     */
    businessHourTitle2?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse
     */
    businessHour2?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'acptNo': !exists(json, 'acptNo') ? undefined : json['acptNo'],
        'acptDtlNo': !exists(json, 'acptDtlNo') ? undefined : json['acptDtlNo'],
        'linkAcptNo': !exists(json, 'linkAcptNo') ? undefined : json['linkAcptNo'],
        'orderConfirmContents': !exists(json, 'orderConfirmContents') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseOrderConfirmContentFromJSON(json['orderConfirmContents']),
        'tel': !exists(json, 'tel') ? undefined : json['tel'],
        'businessHourTitle1': !exists(json, 'businessHourTitle1') ? undefined : json['businessHourTitle1'],
        'businessHour1': !exists(json, 'businessHour1') ? undefined : json['businessHour1'],
        'businessHourTitle2': !exists(json, 'businessHourTitle2') ? undefined : json['businessHourTitle2'],
        'businessHour2': !exists(json, 'businessHour2') ? undefined : json['businessHour2'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'acptNo': value.acptNo,
        'acptDtlNo': value.acptDtlNo,
        'linkAcptNo': value.linkAcptNo,
        'orderConfirmContents': JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseOrderConfirmContentToJSON(value.orderConfirmContents),
        'tel': value.tel,
        'businessHourTitle1': value.businessHourTitle1,
        'businessHour1': value.businessHour1,
        'businessHourTitle2': value.businessHourTitle2,
        'businessHour2': value.businessHour2,
    };
}

